/** @format */

import template from './gb-add-raffle-winners-widget.html';

export const GbAddRaffleWinnersWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddRaffleWinnersWidgetComponent {
        constructor($gbRaffleWinnersProjectorWidget, $ccColors) {
            'ngInject';

            this.$gbRaffleWinnersProjectorWidget = $gbRaffleWinnersProjectorWidget;
            this.$ccColors = $ccColors;
        }

        addWidget() {
            let primaryBgColor = this.gbApp.getAuction().primary_color;
            let accentBgColor = this.gbApp.getAuction().accent_color;

            let widget = new this.$gbRaffleWinnersProjectorWidget({
                x: 25,
                y: 30,
                x_unit: '%',
                y_unit: '%',
                width: 50,
                width_unit: '%',
                height: 65,
                height_unit: '%',
                opacity: 1,
                primary_color: primaryBgColor,
                // primary_text_color: this.$ccColors.getContrast(primaryBgColor),
                accent_color: accentBgColor,
                // accent_text_color: this.$ccColors.getContrast(accentBgColor),
                font_size: 15,
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
